import { render, staticRenderFns } from "./KnowledgeContentContentView.vue?vue&type=template&id=61e82aa5&"
import script from "./KnowledgeContentContentView.vue?vue&type=script&lang=js&"
export * from "./KnowledgeContentContentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports